"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ConfirmationMainContent_1 = require("../confirmationMainContent/ConfirmationMainContent");
var errorMessageHoc_1 = require("../../../../../common/components/presentation/Error/errorMessageHoc");
var ReserveOnlineMessage_1 = require("./ReserveOnlineMessage");
var ConfirmationReserveOnline2C2P = function () {
    return (<ConfirmationMainContent_1.default>
      <ReserveOnlineMessage_1.default />
    </ConfirmationMainContent_1.default>);
};
exports.default = errorMessageHoc_1.default(ConfirmationReserveOnline2C2P);
